import { render, staticRenderFns } from "./FinishRegistration.vue?vue&type=template&id=34391b06&scoped=true"
import script from "./FinishRegistration.vue?vue&type=script&lang=js"
export * from "./FinishRegistration.vue?vue&type=script&lang=js"
import style0 from "./FinishRegistration.vue?vue&type=style&index=0&id=34391b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34391b06",
  null
  
)

export default component.exports